import { WORKSPACE_PERMISSION } from '@constants/workspacePermissions';
import { WORKSPACE_ROLE } from '@constants/workspaceRoles';
import { normalizeWorkspaceRole } from '@utils/formatWorkspaceRole';
import { useWorkspace } from './getQueries';

const useWorkspacePermissions = (workspaceId) => {
  const { data: workspace, isLoading } = useWorkspace(workspaceId);

  if (!workspace || isLoading) {
    return {
      canEdit: false,
      canDelete: false,
      canInvite: false,
      canManageMembers: false,
      canViewSettings: false,
      canManageBilling: false,
      isOwner: false,
      isAdmin: false,
      isMember: false,
      isLoading,
    };
  }

  const userRole = normalizeWorkspaceRole(workspace.user_role);
  const userPermissions = workspace.user_permissions || [];

  // Role-based checks
  const isOwner = userRole === WORKSPACE_ROLE.OWNER;
  const isAdmin = userRole === WORKSPACE_ROLE.ADMIN;
  const isMember = userRole === WORKSPACE_ROLE.MEMBER;
  const isGuest = userRole === WORKSPACE_ROLE.GUEST;

  // Permission-based checks
  const hasAdminPermission = userPermissions.includes(WORKSPACE_PERMISSION.ADMIN);
  const hasEditPermission = userPermissions.includes(WORKSPACE_PERMISSION.EDIT);

  // Derived permissions
  const canEdit = isOwner || hasAdminPermission || hasEditPermission;
  const canDelete = isOwner;
  const canInvite = isOwner || hasAdminPermission;
  const canManageMembers = isOwner || hasAdminPermission;
  const canViewSettings = isOwner || hasAdminPermission || hasEditPermission;
  const canManageBilling = isOwner || hasAdminPermission;

  return {
    canEdit,
    canDelete,
    canInvite,
    canManageMembers,
    canViewSettings,
    canManageBilling,
    isOwner,
    isAdmin,
    isMember,
    isGuest,
    userRole,
    userPermissions,
    isLoading: false,
  };
};

export default useWorkspacePermissions;
